import { Scene } from "three";
export const mainScene = new Scene();
mainScene.matrixAutoUpdate = false;
